import uiBase from "../uiBase";
const { h, classNames, createRef } = omii;
import { readFileAsBase64, createImageFileThumb } from "../utils";
import css from "./index.scss";

// image ={
//   data:
//   file,
// }
export default class extends uiBase {
  static css = css;
  static defaultProps = {
    thumb: false, //true 生成縮略圖
    thumbWidth: 256,
    thumbHeight: 256,
    multiple: false, //多選
    allowSort: false, //多选，并允许排序时才会有排序功能
    viewerImageWidth: 120,
    viewerImageHeight: 120,
    selectText: "选择图片",
    thumbType: "image/webp",
    thumbQuality: 0.95,
    accept: ".jpg, .jpeg, .png, .webp",
  };
  static propsTypes = {
    thumb: Boolean,
    thumbWidth: Number,
    thumbHeight: Number,
    multiple: Boolean, //多選
    allowSort: Boolean,
    viewerImageWidth: Number,
    viewerImageHeight: Number,
  };

  viewerRef = createRef();
  fileInputRef = createRef();
  replaceIndex = -1
  get fileInputId() {
    return `oi__image_selector_${this.elementId}`;
  }
  get image() {
    if (this.images.length) return this.images[0];
  }
  get images() {
    if (this.props.images == undefined) this.props.images = []
    return this.props.images;
  }


  open(index) {
    this.replaceIndex = index
    this.fileInputRef.current.click();
  }
  async processFile(imageFile) {
    let props = this.props;

    if (props.thumb) {
      return createImageFileThumb(
        imageFile,
        props.thumbWidth,
        props.thumbHeight,
        props.thumbType,
        props.thumbQuality
      );
    } else {
      return readFileAsBase64(imageFile);
    }
  }
  remove(index) {
    this.images.splice(index, 1);
    this.updateSelf();
  }
  clean() {
    this.images.splice(0, this.images.length);
    this.updateSelf();
  }
  render(props) {
    let r = null
    if (typeof props.renderFunc == "function") {
      r = props.renderFunc(props, this)
    } else {
      r = <> <label
        class="selector"
        style={`
          width:${props.viewerImageWidth}px;
          height:${props.viewerImageWidth}px
        `}
        title={props.selectText}
        for={this.fileInputId}
      >
      </label>
        <div
          ref={this.viewerRef}
          class={classNames("viewer", { multiple: props.multiple })}
          style={{
            "grid-template-columns": `repeat(auto-fill, ${props.viewerImageWidth}px)`,
          }}
        >
          {this.images.map((image, index) => (
            <div
              class="image"
              style={{
                width: `${props.viewerImageWidth}px`,
                height: `${props.viewerImageHeight}px`,
                backgroundImage: `url(${image?.url})`,
              }}
              onClick={evt => {
                this.open(index)
                evt.preventDefault();
                evt.stopPropagation();
              }}
            >

              <button
                class="remove"
                onclick={(evt) => {
                  this.remove(index);
                  evt.preventDefault();
                  evt.stopPropagation();
                }}
              ></button>
            </div>
          ))}
        </div>
      </>
    }
    return (
      <>
        {r}
        <input
          id={this.fileInputId}
          ref={this.fileInputRef}
          type="file"
          multiple={props.multiple}
          accept={props.accept}
          onchange={async (evt) => {
            let files = evt.target.files;
            if (files?.length == 0) return false
            if (!props.multiple) props.images.splice(0, props.images.length);
            if (this.replaceIndex != -1 && files.length == 1) {
              props.images.splice(this.replaceIndex, 1, {
                url: await this.processFile(files[0]),
                file: files[0],
              });
            } else {
              for (let imageFile of files) {
                props.images.push({
                  url: await this.processFile(imageFile),
                  file: imageFile,
                });
              }
            }

            this.updateSelf();
          }}
        />
      </>
    );
  }
}
